import clsx from 'clsx';
import { forwardRef } from 'react';
import { TextField as AriaTextField, Input as AriaInput } from 'react-aria-components';
import { useController } from 'react-hook-form';
import { Label } from './label';

export const UncontrolledInput = forwardRef(function Input(
  { label, className, suffix, ...props },
  ref,
) {
  return (
    <AriaTextField
      {...props}
      ref={ref}
      className="group/input flex flex-col gap-1"
      data-size={props.size ?? ''}
    >
      <Label>{label}</Label>
      <div
        className="relative after:absolute after:right-4 after:top-1/2 after:-translate-y-3 after:leading-0 after:content-[attr(data-suffix)] after:text-light-500"
        data-suffix={suffix}
      >
        <AriaInput
          className={clsx(
            className,
            'w-full px-3 py-2 group-data-[size=lg]/input:text-lg group-data-[size=lg]/input:p-4 text-body-dark rounded-md border border-solid border-300 shadow-sm placeholder:text-light-500 data-[suffix=true]:pr-11 focus-within:ring-1 ring-primary focus:ring-primary focus:border-primary focus-within:border-primary',
          )}
        />
      </div>
    </AriaTextField>
  );
});

export function Input(props) {
  const { field } = useController({ name: props.name });
  return <UncontrolledInput {...props} {...field} isDisabled={props.disabled} />;
}
